// import React from "react";
// import { Building2, GraduationCap, Trophy, BookOpen, Briefcase, Rocket, Code2, Users, ArrowUpRight } from "lucide-react";
// import { Link } from "react-router-dom";
// import Reveal, { SectionLabel } from "../components/Reveal";
// import { Helmet } from "react-helmet-async";

// <Helmet>
//  <title>
// About JustZeta | Secure Certificate Preservation
// </title>

// <meta
// name="description"
// content="Learn how JustZeta preserves digital certificates and research papers securely for years."
// />
// <meta property="og:type" content="website" />

// <meta property="og:site_name" content="JustZeta" />

// <meta property="og:title"
// content="JustZeta - Secure Digital Certificate Preservation"
// />

// <meta property="og:description"
// content="Long-term preservation of digital certificates and research papers."
// />

// <meta property="og:image"
// content="https://justzeta.com/logo.png"
// />

// <meta property="og:url"
// content="https://justzeta.com"
// /><meta name="twitter:card" content="summary_large_image"/>

// <meta
// name="twitter:title"
// content="JustZeta"
// />

// <meta
// name="twitter:description"
// content="Secure digital certificate preservation."
// />

// <meta
// name="twitter:image"
// content="https://justzeta.com/logo.png"
// />
// <link
// rel="canonical"
// href="https://justzeta.com/about"
// />
// </Helmet>
// const SEAL_IMG =
//   "https://images.unsplash.com/photo-1589330694653-ded6df03f754?crop=entropy&cs=srgb&fm=jpg&w=1200";

// const services = [
//   { icon: Users, title: "Conferences", desc: "Perfect for annual academic conferences with hundreds of presenters and long-tail citation windows." },
//   { icon: GraduationCap, title: "Universities", desc: "Alumni offices trust JustZeta to keep certificate records reachable long after graduation." },
//   { icon: Building2, title: "Institutions", desc: "Government bodies, professional councils and NGOs use JustZeta for programmatic archival." },
//   { icon: Briefcase, title: "Coperate Companies", desc: "Corporate L&D teams issue certificates that need to survive audits, promotions and job changes." },
//   { icon: Code2, title: "Hackathons", desc: "Community organisers preserve every past hackathon's certificate roster in one address." },
//   { icon: Trophy, title: "Workshops", desc: "Short-form workshops still deserve long-form records. We store them from day one." },
//   { icon: BookOpen, title: "Online Courses", desc: "MOOC platforms and independent educators mint durable certificates through JustZeta." },
// ];

// export default function About() {
//   return (
//     <div data-testid="page-about">
//       {/* HERO */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={1}>About JustZeta</SectionLabel>
//           <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
//             <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
//               A digital archival bureau <br />
//               built for the <span className="italic text-neutral-500">long half-life</span> of a certificate.
//             </h1>
//             <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
//             JustZeta helps conferences, institutions, universities, hackathons and training providers preserve digital certificates and research papers securely for years—ensuring every achievement remains accessible whenever it's needed.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* WHO WE ARE */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-16">
//           <div className="md:col-span-5">
//             <SectionLabel>Who we are</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
//               Built to preserve what people earn.
//             </h2>
//           </div>
//           <div className="md:col-span-7 space-y-6 text-neutral-300 text-[17px] leading-relaxed">
//             <p>
//               JustZeta was founded to close a gap that every organiser eventually discovers: the
//               certificate a participant earned in year one is often unreachable by year five. Cloud
//               drives get reshuffled. Domains expire. Email links expire. Websites are decommissioned.
//             </p>
//             <p>
//               We build the opposite: a system whose only job is to remain reachable — not for
//               months, but for the entire retention window you choose. Every artifact is securely stored, protected with enterprise-grade encryption, and organized for easy verification whenever it's needed.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* MISSION + VISION */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
//           <Reveal>
//             <div className="border border-white/10 p-10 h-full">
//               <div className="overline mb-6">Mission</div>
//               <p className="font-serif-display text-3xl leading-[1.15]">
//                 Make every certificate a participant earns <span className="italic text-[#e60000]">permanently retrievable</span>.
//               </p>
//               <p className="mt-8 text-neutral-400 leading-relaxed">
//                 To operate the most trusted, affordable long-term archive for digital certificates
//                 and research papers issued by conferences, institutions and communities.
//               </p>
//             </div>
//           </Reveal>
//           <Reveal delay={0.1}>
//             <div className="border border-white/10 p-10 h-full">
//               <div className="overline mb-6">Vision</div>
//               <p className="font-serif-display text-3xl leading-[1.15]">
//                A future where every digital achievement stays <span className="italic text-[#e60000]">discoverable, secure, and verifiable.</span>.
//               </p>
//               <p className="mt-8 text-neutral-400 leading-relaxed">
//                 We imagine an internet where every legitimate certificate resolves — clean,
//                 verifiable, and unattached to any single employer, vendor or platform.
//               </p>
//             </div>
//           </Reveal>
//         </div>
//       </section>

//       {/* WHY DIGITAL PRESERVATION */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
//           <div className="lg:col-span-6">
//             <img src={SEAL_IMG} alt="Document seal" className="w-full h-[520px] object-cover grayscale" />
//           </div>
//           <div className="lg:col-span-6">
//             <SectionLabel>Why it matters</SectionLabel>
//             <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
//               Digital preservation is <span className="italic text-neutral-500">essential infrastructure.</span>.
//             </h2>
//             <div className="mt-8 space-y-4 text-neutral-300 leading-relaxed">
//               <p>
//                 A certificate is not just a PDF. It's a verifiable statement about a moment in
//                 someone's career. When the link breaks, the statement effectively evaporates —
//                 even though the achievement stays real.
//               </p>
//               <p>
//                 JustZeta treats every certificate as a permanent digital record—securely preserved, easy to verify, and always available when needed.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* BENEFITS FOR */}
//       <section className="border-b border-white/10 py-24 md:py-32">
//         <div className="max-w-7xl mx-auto px-6 md:px-10">
//           <SectionLabel index={2}>Benefits for</SectionLabel>
//           <h2 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.02] max-w-3xl">
//             Every kind of organiser, one archive.
//           </h2>

//           <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
//             {services.map((s, i) => (
//               <Reveal key={s.title} delay={i * 0.05}>
//                 <div className="bg-[#0a0a0a] p-10 h-full hover:bg-[#111] transition-colors">
//                   <s.icon size={22} className="text-[#e60000]" strokeWidth={1.5} />
//                   <h3 className="font-serif-display text-2xl mt-8">{s.title}</h3>
//                   <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">{s.desc}</p>
//                 </div>
//               </Reveal>
//             ))}
//           </div>
//         </div>
//       </section>
// {/* TRUST */}
// <section className="border-b border-white/10 py-24 md:py-32">
//   <div className="max-w-7xl mx-auto px-6 md:px-10">
//     <SectionLabel>Why Trust JustZeta</SectionLabel>

//     <h2 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.05] max-w-4xl">
//       Built with security, reliability and long-term preservation at its core.
//     </h2>

//     <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">

//       <div className="border border-white/10 p-8">
//         <div className="overline mb-4">01</div>
//         <h3 className="font-serif-display text-2xl">
//           Enterprise Security
//         </h3>
//         <p className="mt-4 text-neutral-400 leading-relaxed">
//           Every artifact is encrypted in transit (TLS) and at rest (AES-256),
//           ensuring secure storage throughout its lifecycle.
//         </p>
//       </div>

//       <div className="border border-white/10 p-8">
//         <div className="overline mb-4">02</div>
//         <h3 className="font-serif-display text-2xl">
//           Long-Term Preservation
//         </h3>
//         <p className="mt-4 text-neutral-400 leading-relaxed">
//           Store certificates and research papers for multiple years with
//           consistent accessibility whenever they're needed.
//         </p>
//       </div>

//       <div className="border border-white/10 p-8">
//         <div className="overline mb-4">03</div>
//         <h3 className="font-serif-display text-2xl">
//           Instant Verification
//         </h3>
//         <p className="mt-4 text-neutral-400 leading-relaxed">
//           Every certificate can be verified instantly through a unique digital
//           record, reducing manual verification efforts.
//         </p>
//       </div>

//       <div className="border border-white/10 p-8">
//         <div className="overline mb-4">04</div>
//         <h3 className="font-serif-display text-2xl">
//           Always Accessible
//         </h3>
//         <p className="mt-4 text-neutral-400 leading-relaxed">
//           Participants can securely retrieve their certificates anytime using
//           their registered information.
//         </p>
//       </div>

//     </div>
//   </div>

// {/* <div className="mt-16 border border-[#e60000]/20 bg-[#e60000]/5 p-10">
//   <div className="overline text-[#e60000]">
//     Security
//   </div>

//   <p className="font-serif-display text-3xl mt-4 leading-tight">
//     Every digital artifact is protected with enterprise-grade encryption,
//     secure cloud infrastructure and role-based access controls.
//   </p>
// </div> */}
// </section>
// <section className="py-24">
// <div className="max-w-7xl mx-auto px-6">

// <SectionLabel>Process</SectionLabel>

// <div className="grid md:grid-cols-4 gap-8 mt-12">

// <div>
// <div className="text-[#e60000] text-4xl">01</div>
// <h3 className="mt-4 font-serif-display text-2xl">
// Upload
// </h3>
// <p className="text-neutral-400 mt-3">
// Upload certificates or research papers.
// </p>
// </div>

// <div>
// <div className="text-[#e60000] text-4xl">02</div>
// <h3 className="mt-4 font-serif-display text-2xl">
// Secure Storage
// </h3>
// <p className="text-neutral-400 mt-3">
// Files are securely preserved for the selected retention period.
// </p>
// </div>

// <div>
// <div className="text-[#e60000] text-4xl">03</div>
// <h3 className="mt-4 font-serif-display text-2xl">
// Verification
// </h3>
// <p className="text-neutral-400 mt-3">
// Every record can be verified whenever required.
// </p>
// </div>

// <div>
// <div className="text-[#e60000] text-4xl">04</div>
// <h3 className="mt-4 font-serif-display text-2xl">
// Access Anytime
// </h3>
// <p className="text-neutral-400 mt-3">
// Participants retrieve their records whenever needed.
// </p>
// </div>

// </div>
// </div>
// </section>
//       {/* CTA */}
//       <section className="py-24 md:py-32">
//         <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
//           <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02]">
//             Build an archive that <span className="italic text-neutral-500">outlives the event.</span>
//           </h2>
//           <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
//             <Link
//               to="/pricing"
//               data-testid="about-cta-pricing"
//               className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
//             >
//               See Pricing <ArrowUpRight size={18} />
//             </Link>
//             <Link
//               to="/contact"
//               data-testid="about-cta-contact"
//               className="border border-white/25 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em]"
//             >
//               Talk to us
//             </Link>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }
import React from "react";
import { Building2, GraduationCap, Trophy, BookOpen, Briefcase, Rocket, Code2, Users, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal, { SectionLabel } from "../components/Reveal";
import { Helmet } from "react-helmet-async";

const SEAL_IMG =
  "https://images.unsplash.com/photo-1589330694653-ded6df03f754?crop=entropy&cs=srgb&fm=jpg&w=1200";

const services = [
  { icon: Users, title: "Conferences", desc: "Attach presenter research papers and issue verifiable certificates to hundreds of delegates instantly." },
  { icon: GraduationCap, title: "Universities", desc: "Alumni offices use JustZeta to manage and issue verifiable credentials that remain accessible for years." },
  { icon: Building2, title: "Institutions", desc: "Government bodies, professional councils and NGOs rely on JustZeta for bulk certificate generation and management." },
  { icon: Briefcase, title: "Corporate Companies", desc: "Corporate L&D teams issue training certificates equipped with QR codes for instant background verification." },
  { icon: Code2, title: "Hackathons", desc: "Organizers generate participant and winner certificates from every edition via a single, centralized dashboard." },
  { icon: Trophy, title: "Workshops", desc: "Automate certificate distribution for short-form workshops, allowing attendees to download their records anytime." },
  { icon: BookOpen, title: "Online Courses", desc: "Platform operators and independent educators issue secure, custom-templated course certificates at scale." },
  { icon: Rocket, title: "Marathons & Tournaments", desc: "Issue finisher certificates with timing and rank details for marathons, esports, and sports tournaments." },
];

export default function About() {
  return (
    <div data-testid="page-about">
      <Helmet>
        <title>
          About JustZeta | Certificate Management Platform
        </title>

        <meta
          name="description"
          content="Learn how JustZeta helps organizations generate, manage, and verify digital certificates and research papers."
        />
        <meta property="og:type" content="website" />

        <meta property="og:site_name" content="JustZeta" />

        <meta property="og:title"
          content="JustZeta - Certificate Management"
        />

        <meta property="og:description"
          content="Generate, manage, and verify digital certificates from a single platform."
        />

        <meta property="og:image"
          content="https://justzeta.com/logo.png"
        />

        <meta property="og:url"
          content="https://justzeta.com/about"
        />
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="JustZeta"
        />

        <meta
          name="twitter:description"
          content="The complete certificate management solution."
        />

        <meta
          name="twitter:image"
          content="https://justzeta.com/logo.png"
        />
        <link
          rel="canonical"
          href="https://justzeta.com/about"
        />
      </Helmet>

      {/* HERO */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={1}>About JustZeta</SectionLabel>
          <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
            <h1 className="lg:col-span-8 font-serif-display text-5xl md:text-7xl leading-[1.02]">
              A complete platform <br />
              built for <span className="text-[#e60000]">certificate management.</span>
            </h1>
            <p className="lg:col-span-4 text-neutral-400 leading-relaxed">
              JustZeta helps conferences, institutions, universities, hackathons, and training providers generate, manage, and verify digital certificates and research papers—streamlining administrative workflows and ensuring authenticity.
            </p>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-5">
            <SectionLabel>Who we are</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
              Built to manage what people earn.
            </h2>
          </div>
          <div className="md:col-span-7 space-y-6 text-neutral-300 text-[17px] leading-relaxed">
            <p>
              JustZeta was founded to close a gap that every event organizer eventually discovers: generating, issuing, and verifying certificates is a fragmented, manual process. PDFs get lost, data mapping is tedious, and verifying authenticity post-event is often impossible.
            </p>
            <p>
              We built a system to solve this. Our platform centralizes the entire lifecycle of a certificate. From bulk generation using your custom templates to instant QR-based verification, we provide the modern SaaS infrastructure organizations need to handle credentials professionally and securely.
            </p>
          </div>
        </div>
      </section>

      {/* MISSION + VISION */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6">
          <Reveal>
            <div className="border border-white/10 p-10 h-full">
              <div className="overline mb-6">Mission</div>
              <p className="font-serif-display text-3xl leading-[1.15]">
                Make every generated certificate <span className="italic text-[#e60000]">instantly verifiable</span> and easily accessible.
              </p>
              <p className="mt-8 text-neutral-400 leading-relaxed">
                To provide the most efficient, affordable SaaS platform for generating and managing digital certificates and research papers issued by events and institutions.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="border border-white/10 p-10 h-full">
              <div className="overline mb-6">Vision</div>
              <p className="font-serif-display text-3xl leading-[1.15]">
                A future where digital credentials are <span className="italic text-[#e60000]">seamlessly issued and trusted.</span>
              </p>
              <p className="mt-8 text-neutral-400 leading-relaxed">
                We envision a standard where every legitimate certificate resolves instantly—clean, independently verifiable via QR code, and managed effortlessly from a single dashboard.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* WHY DIGITAL PRESERVATION -> WHY RELIABLE MANAGEMENT */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <img src={SEAL_IMG} alt="Document seal representing authenticity" className="w-full h-[520px] object-cover grayscale" />
          </div>
          <div className="lg:col-span-6">
            <SectionLabel>Why it matters</SectionLabel>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-6 leading-[1.05]">
              Reliable certificate management is <span className="text-[#e60000]">essential infrastructure.</span>
            </h2>
            <div className="mt-8 space-y-4 text-neutral-300 leading-relaxed">
              <p>
                A certificate is not just a PDF; it's a verifiable statement about an individual's participation, skill, or achievement. If a certificate cannot be authenticated, its professional value diminishes significantly.
              </p>
              <p>
                JustZeta equips organizations with the tools to treat every certificate as a secure, verifiable digital asset. By embedding QR codes and centralizing participant data, we ensure every credential carries lasting authority.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS FOR */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index={2}>Built for</SectionLabel>
          <h2 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.02] max-w-3xl">
            Every kind of organizer, one platform.
          </h2>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 border border-white/10">
            {services.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.05}>
                <div className="bg-[#0a0a0a] p-10 h-full hover:bg-[#111] transition-colors">
                  <s.icon size={22} className="text-[#e60000]" strokeWidth={1.5} />
                  <h3 className="font-serif-display text-2xl mt-8">{s.title}</h3>
                  <p className="text-neutral-400 mt-4 leading-relaxed text-[15px]">{s.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="border-b border-white/10 py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel>Why Choose JustZeta</SectionLabel>

          <h2 className="font-serif-display text-4xl md:text-6xl mt-6 leading-[1.05] max-w-4xl">
            Engineered for speed, security, and verification at scale.
          </h2>

          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="border border-white/10 p-8">
              <div className="overline mb-4">01</div>
              <h3 className="font-serif-display text-2xl">
                Bulk Generation
              </h3>
              <p className="mt-4 text-neutral-400 leading-relaxed">
                Import CSV or Excel files to instantly generate thousands of customized certificates in seconds.
              </p>
            </div>

            <div className="border border-white/10 p-8">
              <div className="overline mb-4">02</div>
              <h3 className="font-serif-display text-2xl">
                Custom Templates
              </h3>
              <p className="mt-4 text-neutral-400 leading-relaxed">
                Upload your organization's unique designs. Our system automatically maps dynamic participant details.
              </p>
            </div>

            <div className="border border-white/10 p-8">
              <div className="overline mb-4">03</div>
              <h3 className="font-serif-display text-2xl">
                Instant Verification
              </h3>
              <p className="mt-4 text-neutral-400 leading-relaxed">
                Every certificate contains an embedded QR code, enabling immediate third-party authenticity checks.
              </p>
            </div>

            <div className="border border-white/10 p-8">
              <div className="overline mb-4">04</div>
              <h3 className="font-serif-display text-2xl">
                Long-Term Access
              </h3>
              <p className="mt-4 text-neutral-400 leading-relaxed">
                Guarantee participants secure access to view and download their certificates for up to 50 years.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <SectionLabel>Process</SectionLabel>

    <div className="grid md:grid-cols-4 gap-8 mt-12">
            <div>
              <div className="text-[#e60000] text-4xl">01</div>
              <h3 className="mt-4 font-serif-display text-2xl">
                Onboarding Request
              </h3>
              <p className="text-neutral-400 mt-3">
                Submit an onboarding request. Your organization undergoes verification for secure access.
              </p>
            </div>

            <div>
              <div className="text-[#e60000] text-4xl">02</div>
              <h3 className="mt-4 font-serif-display text-2xl">
                Create Event
              </h3>
              <p className="text-neutral-400 mt-3">
                Set up your event details and upload participant lists via CSV.
              </p>
            </div>

            <div>
              <div className="text-[#e60000] text-4xl">03</div>
              <h3 className="mt-4 font-serif-display text-2xl">
                Finalize Template
              </h3>
              <p className="text-neutral-400 mt-3">
                Upload custom certificate designs or map data to our predefined formal templates.
              </p>
            </div>

            <div>
              <div className="text-[#e60000] text-4xl">04</div>
              <h3 className="mt-4 font-serif-display text-2xl">
                Verify for Years
              </h3>
              <p className="text-neutral-400 mt-3">
                Certificates are issued with embedded QR codes, remaining easily verifiable for years.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32">
        <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.02]">
            Streamline your <span className="text-[#e60000]">certificate management operations.</span>
          </h2>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/pricing"
              data-testid="about-cta-pricing"
              className="bg-[#e60000] hover:bg-[#ff1a1a] text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em] inline-flex items-center gap-3"
            >
              See Pricing <ArrowUpRight size={18} />
            </Link>
            <Link
              to="/contact"
              data-testid="about-cta-contact"
              className="border border-white/25 hover:border-white text-white px-8 py-4 text-[13px] uppercase tracking-[0.22em]"
            >
              Talk to us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}